import { render, staticRenderFns } from "./AdminAppLayout.vue?vue&type=template&id=d4821dac&scoped=true"
import script from "./AdminAppLayout.vue?vue&type=script&lang=js"
export * from "./AdminAppLayout.vue?vue&type=script&lang=js"
import style0 from "./AdminAppLayout.vue?vue&type=style&index=0&id=d4821dac&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4821dac",
  null
  
)

export default component.exports